import {makeStyles} from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    background: 'white',
    padding: '26px 24px',
    borderRadius: '4px'
  },
  item: {
    marginBottom: '22px'
  },
  firstBlock: {
    display: 'flex',
    alignItems: 'flex-start',
    /*'> :first-of-type': {
      marginRight: '45px'
    }*/
    justifyContent:'space-between',
    '> :nth-child(2)': {
      marginLeft: '15px',
      marginRight: '15px'
    }
  },
  attributeList: {
    borderRadius: '12px',
    border: `1px solid ${theme.palette.grey.grey200}`,
    marginBottom: '50px'
  },
  attributeListHeader: {
    borderRadius: '12px 12px 0px 0px',
    borderBottom: `1px solid ${theme.palette.grey.grey200}`,
    padding: '17px 36px',
    /*
        background: 'white'
    */
  },
  attributeListHeaderTitle: {
    fontFamily: 'Inter',
    fontSize: '18px',
    fontWeight: 600
  },
  attributeListContent: {
    margin:'15px 23px',
    backgroundColor: 'rgba(247, 248, 252, 0.40)',
    boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.03) inset',
    padding: '7px 16px'
  },
  placeholder: {
    color: theme.palette.grey.grey400,
    fontSize: '16px',
    lineHeight: '23px',
    letterSpacing: '0.15px',
  },
  errorMessage: {
    display: 'block',
    color: theme.palette.error.error500,
    fontSize: '0.75rem',
    marginTop: '-5px'
  },
  inputHelper: {
    color: theme.palette.grey.main,
    fontSize: '12px',
  },
}));

export default useStyles;
